<a id="logo" href="https://informally.io">
  <img class="logo" src="/assets/logo-informally.svg" />
</a>

@if (isAuthResolved && isExistingUser) {
  <div class="top-right-user-status">
    <div class="signed-in-copy">Signed in as</div>
    <div class="signed-in-user">{{ signedInUserLabel }}</div>
    <button
      mat-stroked-button
      type="button"
      color="primary"
      [disabled]="isLoggingOut"
      (click)="onLogout()"
    >
      @if (isLoggingOut) {
        Logging out...
      } @else {
        Log out
      }
    </button>
  </div>
}

<div class="container">
  <mat-card appearance="outlined" #card [class.single-step-card]="isAuthResolved && isExistingUser">
    <div class="form-warning" *ngIf="formError">
      <mat-icon>warning</mat-icon>
      <span>{{ formError }}</span>
    </div>
    @if (!isAuthResolved) {
      <div class="loading-stall">
        <div class="loading-text">Loading…</div>
      </div>
    } @else if (isExistingUser) {
      <div class="step-container single-step">
        <div class="single-step-header">
          <h2>New shop details</h2>
          <p>Provide the essentials to create your shop.</p>
        </div>
        <app-shop-details-step [parentFormGroup]="formGroup" controlName="shopDetails" />
        <div class="controls">
          <div style="visibility: hidden"></div>
          <button
            [disabled]="formGroup.controls.shopDetails?.invalid || isSubmitting"
            mat-flat-button
            color="primary"
            (click)="onSubmit()"
          >
            <span class="submit-button-content">
              @if (isSubmitting) {
                <mat-spinner diameter="18"></mat-spinner>
                <span>Creating shop...</span>
              } @else {
                <span>Create Shop</span>
              }
            </span>
          </button>
        </div>
      </div>
    } @else {
      <mat-stepper [linear]="true">
        <mat-step>
          <div class="step-container">
            <ng-template matStepLabel>Your Experience</ng-template>
            <app-prior-experience-step
              [parentFormGroup]="questionnaireFormGroup"
              controlName="priorExperience"
            />
            <div class="controls">
              <div style="visibility: hidden"></div>
              <button
                [disabled]="!questionnaireFormGroup.controls.priorExperience.valid"
                mat-flat-button
                color="primary"
                matStepperNext
              >
                Next
              </button>
            </div>
          </div>
        </mat-step>

        <mat-step>
          <div class="step-container">
            <ng-template matStepLabel>Your Goals</ng-template>
            <app-requirements-step
              [parentFormGroup]="questionnaireFormGroup"
              controlName="purposes"
            />
            <div class="controls">
              <button mat-flat-button color="primary" matStepperPrevious>Back</button>
              <button
                [disabled]="!questionnaireFormGroup.controls.purposes.valid"
                mat-flat-button
                color="primary"
                matStepperNext
              >
                Next
              </button>
            </div>
          </div>
        </mat-step>

        <mat-step>
          <div class="step-container">
            <ng-template matStepLabel>Your Shop</ng-template>
            <app-shop-details-step [parentFormGroup]="formGroup" controlName="shopDetails" />
            <div class="controls">
              <button mat-flat-button color="primary" matStepperPrevious>Back</button>
              <button
                [disabled]="formGroup.controls.shopDetails?.invalid || isSubmitting"
                mat-flat-button
                color="primary"
                matStepperNext
                (click)="onSubmit()"
              >
                <span class="submit-button-content">
                  @if (isSubmitting) {
                    <mat-spinner diameter="18"></mat-spinner>
                    <span>Creating shop...</span>
                  } @else {
                    <span>Create Shop</span>
                  }
                </span>
              </button>
            </div>
          </div>
        </mat-step>
      </mat-stepper>
    }
  </mat-card>
</div>
